import React from "react";
import { Image, Linking, Pressable } from "react-native";
import {
  Box,
  MainButton,
  MainText,
  PressableOpacity,
  MainTitle,
} from "app/components/common";
import { UserProfileBlock } from "../UserProfileBlock";
import mbtiJouvieGroup from "../../../../assets/images/mbtiJouvieGroup.png";
import theme from "app/Theme/Theme";
import ArrowRightSlider from "app/components/Icons/ArrowSlider/ArrowRightSlider";
import { useNavigation } from "@react-navigation/native";
import {
  getLanguage,
  getProfileSettingsMbti,
} from "@microdoing/shared/services/profileSettings/selectors";
import { useSelector } from "react-redux";
import i18n from "@microdoing/shared/i18n";
import { getMbtiOptions } from "../MbtiSelectorScreen/MbtiLibrary";
import normalize from "app/utils/normalize";
import { getMbti } from "@microdoing/shared/services/user/selectors";

const mbtiTestLinkFr =
  "https://www.16personalities.com/fr/test-de-personnalite";

const mbtiTestLinkEn = "https://www.16personalities.com/free-personality-test";

const MbtiMainContent = () => {
  const navigation = useNavigation();

  const language = useSelector(getLanguage);
  const openMbti = () => {
    if (language === "fr") {
      Linking.openURL(mbtiTestLinkFr);
    } else {
      Linking.openURL(mbtiTestLinkEn);
    }
  };

  const navigateToMbti = () => {
    navigation.navigate("Mbti");
  };

  const userMbti = useSelector(getProfileSettingsMbti);
  const userMbtiData = getMbtiOptions(language).find(
    item => item.key === userMbti,
  );
  return (
    <Box flex={1}>
      <Box flexDirection="column">
        <Box flex={1}>
          {!userMbti ? (
            <MainText variant="l3-medium" color="neutral.600">
              {i18n.t("mbti-explanation")}
            </MainText>
          ) : (
            <MainText variant="l3-medium" color="neutral.600" marginRight="l">
              {userMbtiData?.description}
            </MainText>
          )}
        </Box>
        <Box marginVertical="xm" alignItems="center">
          <Image
            source={!userMbti ? mbtiJouvieGroup : userMbtiData?.image}
            style={{ width: normalize(140), height: normalize(100) }}
            resizeMode="contain"
          />
        </Box>
      </Box>
      {!userMbti && (
        <PressableOpacity onPress={openMbti}>
          <MainText textAlign="center" variant="l5-medium" color="brand.500">
            {i18n.t("complete-mbti-test")}
          </MainText>
        </PressableOpacity>
      )}
      <Box alignItems="center">
        {!userMbti ? (
          <MainButton
            color="brand.500"
            textColor="neutral.white"
            text={i18n.t("select-my-profile")}
            onPress={navigateToMbti}
            rightIcon={<ArrowRightSlider color={theme.colors["brand.500"]} />}
            isContentCenter
          />
        ) : (
          <PressableOpacity onPress={navigateToMbti}>
            <MainText variant="l5-medium" color="brand.500">
              {i18n.t("select-my-profile")}
            </MainText>
          </PressableOpacity>
        )}
      </Box>
    </Box>
  );
};

export const MbtiBlock = () => {
  const language = useSelector(getLanguage);
  const userMbti = useSelector(getProfileSettingsMbti);
  const userMbtiData = getMbtiOptions(language).find(
    item => item.key === userMbti,
  );

  return (
    <UserProfileBlock
      title={
        !!userMbti ? (
          <Box flexDirection="row" alignItems="flex-end" justifyContent="flex-end">
            <MainTitle marginRight="xs" variant="l6-bold"  >
              {userMbtiData?.title || ""}
            </MainTitle>
            <MainText color="brand.500" variant="l4-bold" style={{ marginBottom: 1}} >
              {userMbtiData?.label || ""}
            </MainText>
          </Box>
        ) : (
          <MainTitle variant="l6-bold">MBTI</MainTitle>
        )
      }
      mainContent={<MbtiMainContent />}
    />
  );
};
